import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';
import { Tabs as TabsComponent } from '../tabs-new';
import { NAV_HEIGHT } from './constants';
import { zindex } from 'src/ui/zindex';

const SPACE_FOR_HEADER_MARGIN = 4;

type TabsProps = {
  background?: boolean;

  isSticky?: boolean;
  $headerIsVisible?: boolean;
  bleed: { left: number; right: number };
};

export const Tabs = styled(TabsComponent)<TabsProps>(
  p => css`
    position: sticky;
    top: ${p.$headerIsVisible ? layout.headerHeight.desktop.rem : 0};
    background: ${p.theme.bg.primary};
    z-index: ${zindex.menu.sticky.normal};
    ${p.background &&
    css`
      z-index: ${p.isSticky
        ? zindex.menu.sticky.background.isSticky
        : zindex.menu.sticky.background.default};
    `};
    height: ${`${NAV_HEIGHT}px`};

    ${media.smallOnly`
      top: ${p.$headerIsVisible ? layout.headerHeight.mobile.rem : 0};
      height: ${`${NAV_HEIGHT - SPACE_FOR_HEADER_MARGIN}px`};
    `};
  `
);
